/**
 * Jirani logo — bold monogram "J" with a warm leaf flourish on top.
 * Cream J on terracotta rounded background, forest-green + amber accents.
 */
export function JiraniLogoMark({ className = "h-9 w-9", ...props }) {
  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Jirani logo"
      className={className}
      {...props}
    >
      {/* Rounded terracotta background */}
      <rect x="0" y="0" width="48" height="48" rx="12" fill="#D95D39" />

      {/* Monogram J — bold cream stroke */}
      <path
        d="M31 13 L31 30 Q31 38 22 38 Q13 38 13 30"
        fill="none"
        stroke="#F9F7F4"
        strokeWidth="5.5"
        strokeLinecap="round"
      />

      {/* Warm amber dot / sun crowning the J */}
      <circle cx="31" cy="10" r="3.5" fill="#F4A261" />
    </svg>
  );
}

export function JiraniLogo({ subtitle = "Karibu jirani", size = "md", showSubtitle = true }) {
  const markSize = size === "sm" ? "h-8 w-8" : size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const wordSize = size === "sm" ? "text-base" : size === "lg" ? "text-xl" : "text-lg";

  return (
    <span className="flex items-center gap-2">
      <JiraniLogoMark className={`${markSize} shadow-[0_10px_20px_-10px_rgba(217,93,57,0.6)] rounded-xl`} />
      <span className="leading-none">
        <span
          className={`block font-bold tracking-tight text-[#1A1A1A] ${wordSize}`}
          style={{ fontFamily: "Outfit" }}
        >
          Jirani<span className="text-[#D95D39]">.</span>co
        </span>
        {showSubtitle && (
          <span className="mt-0.5 block text-[10px] uppercase tracking-[0.22em] text-[#2E473B]">
            {subtitle}
          </span>
        )}
      </span>
    </span>
  );
}

export default JiraniLogo;
